import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { Theme } from '@navegasistemas/dls-navega-rjs'

interface ThemeStore {
  themeName: string
  setTheme: (theme: Theme) => void
}

export const useThemeStore = create<ThemeStore>()(
  persist(
    (set) => ({
      themeName: 'light',
      setTheme: (theme) => set({ themeName: theme.name }),
    }),
    { name: 'navega-theme' },
  ),
)
